export default "__VITE_ASSET__kK2NnBzR__"